export default ({
	headerName,
	headerAlignment,
	headerSize,
	marginBottom,
	paddingLeft,
}) => {
	return {
		headerName,
		headerAlignment,
		headerSize,
		marginBottom,
		paddingLeft,
	};
};
